module.exports = __webpack_public_path__ + "img/tourism_bodycar.dfdcff5b.png";